import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const initialContext = {
  onLog: console.error
};
const ErrorBoundaryContext = createContext(initialContext);
const ErrorBoundaryProvider = ({
  children,
  onLog = () => null
}) => {
  return /* @__PURE__ */ jsx(ErrorBoundaryContext.Provider, { value: { onLog }, children });
};
function useErrorBoundary() {
  return useContext(ErrorBoundaryContext);
}
export {
  ErrorBoundaryContext,
  ErrorBoundaryProvider,
  useErrorBoundary
};
//# sourceMappingURL=error-boundary.provider.js.map
